import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-more",
  "use": "icon-more-usage",
  "viewBox": "-1 -1 65 65",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-1 -1 65 65\" id=\"icon-more\"><path d=\"M31.59,0A31.31,31.31,0,0,1,63,31.68,31.33,31.33,0,0,1,31.4,63,31.31,31.31,0,0,1,0,31.31,31.28,31.28,0,0,1,31.59,0ZM21.86,31.53a5.11,5.11,0,0,0-5-5,5,5,0,0,0-.08,9.94A5.09,5.09,0,0,0,21.86,31.53Zm14.6-.1a5,5,0,1,0-4.94,5A5.1,5.1,0,0,0,36.46,31.43Zm9.62-4.91a5,5,0,1,0,5,5A5.13,5.13,0,0,0,46.08,26.52Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol